"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var createSvg_1 = require("./web/createSvg");
var SVG = require('@svgdotjs/svg.js').SVG;
var ChartWeb = function (props) {
    var _a, _b, _c;
    var wrap = React.useRef(null);
    var chart = React.useRef(null);
    var getXYIndexCallback = React.useRef(null);
    var Size;
    (function (Size) {
        Size[Size["LG"] = 0] = "LG";
        Size[Size["MD"] = 1] = "MD";
        Size[Size["SM"] = 2] = "SM";
    })(Size || (Size = {}));
    var _d = React.useState(props.config), config = _d[0], setConfig = _d[1];
    var onPointerMove = function (e) {
        if (!e.currentTarget)
            return;
        var deltaX = e.clientX - e.currentTarget.getBoundingClientRect().left;
        var cursor = deltaX * (config.charts[0].width / e.currentTarget.offsetWidth);
        setConfig(function (c) { return (__assign(__assign({}, c), { charts: [__assign(__assign({}, c.charts[0]), { cursorX: cursor })] })); });
    };
    var onClick = function (e) {
        if (!e.currentTarget)
            return;
        var deltaX = e.clientX - e.currentTarget.getBoundingClientRect().left;
        var deltaY = e.clientY - e.currentTarget.getBoundingClientRect().top;
        var cursorX = deltaX * (config.charts[0].width / e.currentTarget.offsetWidth);
        var cursorY = deltaY * (config.charts[0].height / e.currentTarget.offsetHeight);
        var nearest = getXYIndexCallback.current(cursorX, cursorY);
        props.onBarClick ? props.onBarClick(nearest.indexX, nearest.indexY) : null;
    };
    var onResize = function () {
        if (!wrap.current)
            return;
        var elm = wrap.current;
        var width = elm.clientWidth;
        var size = width > 1100 ? Size.LG : (width > 700 ? Size.MD : Size.SM);
        var getNewConfig = function (oldConfig) {
            return __assign(__assign({}, oldConfig), { charts: oldConfig.charts.map(function (it) { return (__assign(__assign({}, it), { height: heights[size], xAxis: __assign(__assign({}, it.xAxis), { fontSize: fontSizes[size] }), yAxis: __assign(__assign({}, it.yAxis), { fontSize: fontSizes[size], marginStart: yAxisMarginStarts[size], marginEnd: yAxisMarginStarts[size] * 1.4 }) })); }) });
        };
        setConfig(getNewConfig);
    };
    React.useEffect(function () {
        var canvas = SVG();
        var element = chart.current;
        if (element)
            element.innerHTML = '';
        canvas.addTo(element);
        var getXYIndex = createSvg_1.createSvg(canvas, config).getXYIndex;
        getXYIndexCallback.current = getXYIndex;
    }, [config]);
    React.useEffect(function () {
        setConfig(props.config);
        onResize();
    }, [props.config]);
    React.useEffect(function () {
        if (!wrap.current)
            return;
        var elm = wrap.current;
        window.addEventListener('resize', onResize);
        elm.addEventListener('pointermove', onPointerMove);
        elm.addEventListener('click', onClick);
        onResize();
    }, []);
    var heights = (_a = {}, _a[Size.LG] = 600, _a[Size.MD] = 700, _a[Size.SM] = 800, _a);
    var fontSizes = (_b = {}, _b[Size.LG] = 20, _b[Size.MD] = 32, _b[Size.SM] = 54, _b);
    var yAxisMarginStarts = (_c = {}, _c[Size.LG] = 70, _c[Size.MD] = 90, _c[Size.SM] = 120, _c);
    return (React.createElement("div", { style: { width: '100%', touchAction: 'none', position: 'relative' } },
        React.createElement("div", { ref: wrap, style: { position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 } }),
        React.createElement("div", { ref: chart })));
};
exports.default = ChartWeb;
